/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 35 40" fill="none">
    <g clipPath="url(#clip0_6866_1365)">
      <path d="M22.5 35C22.5 36.3281 21.9766 37.6016 21.0391 38.5391C20.1016 39.4766 18.8281 40 17.5 40C16.1719 40 14.8984 39.4766 13.9609 38.5391C13.0234 37.6016 12.5 36.3281 12.5 35H17.5H22.5Z" fill="#459796"/>
      <path opacity="0.4" d="M17.5 0C16.1172 0 15 1.11719 15 2.5V4C9.29684 5.15625 4.99997 10.2031 4.99997 16.25V17.7188C4.99997 21.3906 3.64841 24.9375 1.21091 27.6875L0.632782 28.3359C-0.0234681 29.0703 -0.179718 30.125 0.218719 31.0234C0.617157 31.9219 1.51559 32.5 2.49997 32.5H32.5C33.4843 32.5 34.375 31.9219 34.7812 31.0234C35.1875 30.125 35.0234 29.0703 34.3672 28.3359L33.789 27.6875C31.3515 24.9375 30 21.3984 30 17.7188V16.25C30 10.2031 25.7031 5.15625 20 4V2.5C20 1.11719 18.8828 0 17.5 0Z"
        fill="#459796"/>
    </g>
    <defs>
      <clipPath id="clip0_6866_1365">
        <rect width="35" height="40" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
